<template>
    <bottom-dialog v-model="showDialog" :dialog="true" max-width="550px">
        <v-card flat tile>
            <v-card-title class="headline pa-2 primary primarytext--text d-flex fill-width">
                {{$translate(add ? 'Search team' : 'Edit the post')}}
                <v-spacer />
                <v-btn icon @click="showDialog = false" ><v-icon class="primary primarytext--text">mdi-close</v-icon></v-btn>
            </v-card-title>

            <v-card-text class="mt-4">
                <FormField :field="sportField" v-model="changed.teamsport_ids" />

                <FormField :field="commentField" v-model="changed.comment" />

            </v-card-text>

            <v-card-actions>
                <v-btn v-if="!add" color="error" @click="removePost">{{$translate('Remove post')}}</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="save" :loading="saving" :disabled="!canSave">{{$translate('Save')}}</v-btn>
            </v-card-actions>
        </v-card>
    </bottom-dialog>
</template>

<script>
import BottomDialog from '../components/BottomDialog.vue';
import FormField from '../components/FormField.vue';
export default {
    name: 'zoezi-teamsport-player-pool-team-post-dialog',
    props: {
        value: {
            type: Boolean
        },
        add: {
            type: Boolean
        },
        post: {
            type: Object
        },
        teamsports: {
            type: Array
        }
    },

    components: {
        BottomDialog,
        FormField
    },

    watch: {
        value: {
            immediate: true,
            handler(show) {
                if (show) {
                    if (this.add) {
                        this.changed.teamsport_ids = null;
                        this.changed.comment = null;
                    } else {
                        this.changed.teamsport_ids = this.post.teamsport_ids;
                        this.changed.comment = this.post.comment;
                    }
                }
            }
        }
    },

    data: () => ({
        changed: {
            teamsport_ids: null,
            comment: null
        },
        saving: false
    }),

    computed: {
        showDialog: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        },
        sportField() {
            return {
                type: 'multiselect',
                title: 'Sport',
                placeholder: 'Choose one or more sports',
                data: this.teamsports?.map(teamsport => {
                    return {
                        text: teamsport.name,
                        value: teamsport.id
                    }
                })
            }
        },
        commentField() {
            return {
                type: 'textarea',
                title: 'Describe yourself'
            }
        },
        canSave() {
            return this.changed.teamsport_ids && this.changed.teamsport_ids.length > 0 && this.changed.comment
        }
    },
    methods: {
        possiblyShowError(response) {
            if (!response.ok) {
                response.json().then(data => {
                    this.$store.commit('showErrorDialog', { title: this.$translate('Error'), text: `${this.$translate('Something went wrong')}. ${this.$translate(data?.message)}`});
                });
            }
        },
        save() {
            if (this.add) {
                const data = {
                    teamsport_ids: this.changed.teamsport_ids,
                    comment: this.changed.comment
                }
                this.saving = true;
                this.$api.post('/api/playerpooluser/add', data).then(response => {
                    if (response.ok) {
                        this.showDialog = false
                    }
                    this.saving = false;
                    this.possiblyShowError(response)
                });
            } else {
                const data = {
                    teamsport_ids: this.changed.teamsport_ids,
                    comment: this.changed.comment,
                    id: this.post.id
                }
                this.saving = true;
                this.$api.post('/api/playerpooluser/change', data).then(response => {
                    if (response.ok) {
                        this.showDialog = false
                    }
                    this.saving = false;
                    this.possiblyShowError(response)
                });
            }
        },
        removePost() {
            this.$store.commit('showConfirmDialog', {
                title: this.$translate('Remove post'),
                text: this.$translate('Are you sure you want to remove the post?'),
                actionText: this.$translate('Remove'),
                action: () => {
                    this.$api.post('/api/playerpooluser/remove', null, {id: this.post.id}).then(response => {
                        if (response.ok) {
                            this.showDialog = false
                        }
                        this.possiblyShowError(response)
                    });
                }
            });
        }
    }
}
</script>
